import { action, observable, makeObservable } from 'mobx';
import { Minuta, Processo } from '../modelo';
import ControleGabineteStore from './ControleGabineteStore';
import MensagemStore from './MensagemStore';
import MinutaService from '../services/MinutaService';
import ProcessoStore from './ProcessoStore';
import ProcessoService from '../services/ProcessoService';

class MovimentacaoExternaStore {
    openModal = false;
    openModalDevolver = false;
    modalAberto = false;
    labelBotao = 'Enviar Para Pauta';
    desabilitarBotao = false;
    openModalProximaTarefa = false;
    observacao = '';
    motivoAndamento: number = 0;
    erroFaltaMotAnd = false;

    ativarBotao = (label: string) => {
        this.labelBotao = label;
        this.desabilitarBotao = false;
    };

    desativarBotao = (label: string) => {
        this.labelBotao = label;
        this.desabilitarBotao = false;
    };

    abrirModal = () => {
        this.openModal = true;
    };

    fecharModal = () => {
        this.openModal = false;
    };

    constructor() {
        makeObservable(this, {
            openModal: observable,
            openModalDevolver: observable,
            modalAberto: observable,
            labelBotao: observable,
            desabilitarBotao: observable,
            openModalProximaTarefa: observable,
            observacao: observable,
            motivoAndamento: observable,
            erroFaltaMotAnd: observable,
            ativarBotao: action,
            desativarBotao: action,
            abrirModal: action,
            fecharModal: action
        });
    }
}

export default new MovimentacaoExternaStore();